var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4251 6.91018C16.4936 6.98122 16.5489 7.06391 16.5884 7.15435C16.5988 7.17648 16.6058 7.19926 16.6131 7.2227C16.614 7.22574 16.615 7.22879 16.6159 7.23185C16.6401 7.30147 16.6544 7.37411 16.6584 7.44768C16.6592 7.45612 16.6616 7.46403 16.6639 7.47182C16.6666 7.48095 16.6693 7.48991 16.6693 7.49935V16.666C16.6693 17.5852 15.9218 18.3327 15.0026 18.3327H5.0026C4.08344 18.3327 3.33594 17.5852 3.33594 16.666V3.33268C3.33594 2.41352 4.08344 1.66602 5.0026 1.66602H10.8359C10.8455 1.66602 10.8546 1.66876 10.8637 1.67152C10.8713 1.6738 10.8788 1.67609 10.8868 1.67685C10.9603 1.68133 11.0329 1.69562 11.1026 1.71935C11.1109 1.7222 11.1192 1.72482 11.1275 1.72742C11.1457 1.73315 11.1637 1.73882 11.1809 1.74685C11.2714 1.78636 11.3541 1.84167 11.4251 1.91018L16.4251 6.91018ZM11.6693 6.66602H13.8243L11.6693 4.51102V6.66602ZM5.0026 3.33268V16.666H15.0043L15.0026 8.33268H10.8359C10.6149 8.33268 10.403 8.24488 10.2467 8.0886C10.0904 7.93232 10.0026 7.72036 10.0026 7.49935V3.33268H5.0026ZM13.3359 11.666V9.99935H6.66927V11.666H13.3359ZM13.3359 14.9993V13.3327H6.66927V14.9993H13.3359ZM8.33594 6.66602H6.66927V8.33268H8.33594V6.66602Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxFile);
export default __webpack_public_path__ + "static/media/bx-file.66c6c95a37e80b50c1ec1f28f148b81f.svg";
export { ForwardRef as ReactComponent };